/**
 * @file 对axios请求的二次封装
 * @Author ytyjm
 * @Create Time 2020/3/23
 * @Description:
 */

import http from './axios'
import Qs from 'qs'

/**
 * fetchData
 * @param {String} url 请求地址
 * @param {String} method 请求方式
 * @param {Object} data 请求参数
 * @returns res.data
 */
export const fetchData = async (url, method, data = null) => {
  let httpOpts = { url, method }
  httpOpts = method === 'get' ? {
    ...httpOpts,
    params: data,
    paramsSerializer: params => Qs.stringify(params, { indices: false })  // 序列化 处理数组
  } : { ...httpOpts, data }

  try {
    const res = await http(httpOpts)
    return res.data
  } catch (error) {
    return null
  }

  // 使用 .then .catch 情况
  // return http(httpOpts).then(res => {
  // return res.data
  // }).catch(err => {
  // return null
  // })
}
